import { SagaObject } from '@models/imported/SagaBase/SagaObject';

export class CardParticularsWrapper<T extends SagaObject> {
  extended: boolean = false;

  constructor(public readonly wrappedParticular: T) {}
}
